/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_ResultsInputs */

const en_recipes_results = /** @type {(inputs: Recipes_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results`)
};

const de_recipes_results = /** @type {(inputs: Recipes_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treffer`)
};

/**
* | output |
* | --- |
* | "Results" |
*
* @param {Recipes_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_results = /** @type {((inputs?: Recipes_ResultsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_ResultsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_results(inputs)
	return en_recipes_results(inputs)
});